<template>
  <div id="SelectedTable" class="select-content">
    <div class="result-box">
      <div class="text"><span>共 {{totalCount}} 个产品</span><span v-if="selected.length">，已选中其中 {{selected.length}} 个产品</span></div>
      <div v-if="categoryType === 'fan'">
        <el-button type="primary" :disabled="!selected.length" @click="startExportExcel">导出设备表</el-button>
      </div>
    </div>
    <div class="table-box">
      <gjw-loading v-if="tableLoading"></gjw-loading>
      <el-table
          v-else
          :key="categoryCode"
          :data="tableData"
          v-load-more.expand="{func: loadData, target: '.el-table__body-wrapper', delay: 300, distance: 10}"
          :load-more-disabled="stopLoadData"
          :max-height="tableMaxHeight"
          :span-method="spanMethod"
          @selection-change="handleSelectionChange"
          :row-class-name="rowClassNameMethod"
          :row-style="rowStyleMethod"
          :cell-style="cellStyleMethod"
          row-key="id"
          style="width: 100%;"
      >
        <el-table-column
            v-if="categoryType === 'fan'"
            type="selection"
            width="32"
            :selectable="selectableMethod"
            :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column v-else width="1" />
        <el-table-column label="产品型号" prop="model" min-width="180px">
          <template v-slot="scope">
            <product-model-col :row="scope.row" @image-click="toDetail" @model-click="toDetail" />
          </template>
        </el-table-column>
        <el-table-column label="设备编号" prop="equipmentNum" min-width="110px">
          <template v-slot="scope">
            <col-input 
                :row="scope.row" 
                :row-index="scope.$index"
                property="equipmentNum"
                :default-value="scope.row.equipmentNum"
                @handle-editing="bool=>updateEditStatus(scope.row, bool)"
                @update-value="values=>scope.row.equipmentNum = values"
            />
          </template>
        </el-table-column>
          <el-table-column
            v-for="col in columns"
            :key="col.prop"
            :label="col.label"
            :prop="col.prop"
            show-overflow-tooltip
            :width="col.width"
            :min-width="col.minWidth"
            :formatter="col.fmtValue"
          >
            <template v-if="col.toolTip" #header>
              <div class="flex-container flex-row flex-verti-center">
                <div>{{ col.toolTip.name }}</div>
                <el-tooltip effect="dark" placement="top-start" :content="col.toolTip.content">
                  <i class="icon-hover" :class="col.toolTip.iconClass"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        <el-table-column label="操作" width="110px">
          <template v-slot="scope">
            <el-button
                type="text"
                @click="toDetail(scope.row)"
                :disabled="scope.row.isOffline">查看</el-button>
            <el-button
                v-if="platform !== 'web'"
                type="text"
                @click="toPlace(scope.row)"
                :disabled="scope.row.isOffline">布置</el-button>
            <el-button
                type="text"
                @click="toRemove(scope.row, scope.$index)"
                :disabled="removingIndex === scope.$index"
                title="移除选中产品">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import GjwLoading from '@/components/lib/GjwLoading'
import ProductModelCol from '@/views/products/components/ProductModelCol.vue'
import ColInput from './ColInput.vue'
import goToPage from '@/mixins/goToPageMixin'
import productPlaceComponentMixin from '@/mixins/productPlaceComponentMixin'

export default {
  name: 'SelectedTable',
  components: { GjwLoading, ProductModelCol, ColInput },
  mixins: [goToPage, productPlaceComponentMixin],
  props: {
    // table的最大高度
    tableMaxHeight: {
      type: [String, Number],
    },
    // 品类：fan/pump/basic
    categoryType: {
      type: String,
      require: true
    },
    // 品类Code
    categoryCode: {
      type: [String, Number],
      require: true
    },
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    tableData: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      removingIndex: -1,
      // 已勾选的数据
      selected: [],
      temp: null
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      tableLoading: 'selectionList/tableLoading',
      totalCount: 'selectionList/totalCount',
      project: 'selectionList/project',
      shareDefinitions: 'shareParams/shareDefinitions',
    }),
    stopLoadData() {
      return this.totalCount <= this.tableData.length
    },
  },
  methods: {
    ...mapMutations({
      removeProjectProductsData: 'selectionList/removeProjectProductsData',
      setTotalCount: 'selectionList/setTotalCount',
    }),
    ...mapActions({
      loadProjectProducts: 'selectionList/loadProjectProducts'
    }),
    updateEditStatus(row, bool) {
      row.isEditing = bool
    },
    loadData() {
      if (this.stopLoadData) { return }
      const params = {
        gjw_category_code: this.categoryCode
      }
      this.loadProjectProducts(params)
    },
    resetTable() {
      this.selected = []
    },
    rowClassNameMethod({ row }) {
      return this.selected.some((item) => item.id && item.id === row.id) ? 'selected-row' : ''
    },
    rowStyleMethod({ row }) {
      return row.isOffline ? { color: '#d2d7dc' } : ''
    },
    cellStyleMethod({ row, columnIndex }) {
      return row.isOffline && columnIndex === 3 ? { 'text-align': 'center' } : ''
    },
    spanMethod({ row, columnIndex }) {
      // 每个品类的列数不一定一样，需分开判断
      const colSpanStartIndex = 3
      // 需要去掉3列
      const colSpanEndIndex = this.columns.length + 2
      const colSpanCount = colSpanEndIndex - colSpanStartIndex + 1
      // 必须给每个单元格都设置 rowspan 和 colspan, 被占用的单元格必须设置[0,0];
      if (row.isOffline) {
        if (columnIndex === colSpanStartIndex) {
          return [1, colSpanCount]
        } else if (columnIndex > colSpanStartIndex && columnIndex <= colSpanEndIndex) {
          return [0, 0]
        } else {
          return [1, 1]
        }
      } else {
        return [1, 1]
      }
    },
    selectableMethod(row) {
      return !row.isOffline
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    toDetail(row) {
      if (row.isEditing) {
        // 当该行正在编辑的时候，需要等编辑保存接口有返回之后，再进行业务操作
        setTimeout(() => this.toDetail(row), 100)
      } else {
        // 获取设计点属性信息及值
        const designProperties = row.designProperties
        designProperties.forEach((dp) => {
          let newValues
          if (dp.codes.includes('/')) {
            newValues = dp.values.split('/').map((p) => p === '-' ? '' : p).join('/')
            if (newValues === '/') {
              newValues = null
            }
          } else {
            newValues = dp.values === '-' ? null : dp.values
          }
          dp.values = newValues
        })
        const routeInfo = {
          name: 'ProductDetail',
          params: { id: row.productId },
          query: {
            designProperties: JSON.stringify(designProperties)
          }
        }
        this.toPage(routeInfo)
      }
    },
    // 布置(R/G)
    async toPlace(row) {
      if (row.isEditing) {
        setTimeout(() => this.toPlace(row), 100)
      } else {
        this.$fullLoading.open(this.$t('load.downloading'))
        // 获取布置产品时需要的相关信息
        const payload = this.platform === 'r' ? {
          personalProductId: row.id,
          softwareCode: this.softwareCode,
          softwareVersion: this.softwareVersion,
        } : {
          productId: row.productId,
          equipmentNum: row.equipmentNum || null,
          powerConsumptionPerAirVolume: row.powerConsumptionPerAirVolume || null,
          designProperties: row.designProperties || null,
          runtimeProperties: row.runtimeProperties || null,
        }
        const trackPartParams = {
          g_c_product_id: row.productId,
          g_c_source: 'selected_product',
        }
        try {
          const placeFunc = this.platform === 'r' ? this.placeRevitComponent : this.placeGcsComponent
          await placeFunc({ payload, trackPartParams, recordMethodName: 'PlacePublicComponentFromSelectionList' })
        } finally {
          this.$fullLoading.close()
        }
      }
    },
    async toRemove(row, index) {
      // 由于有触底加载，所以不能刷新列表，只能前端把数据从列表中移除
      try {
        this.removingIndex = index
        await this.$api.project.cancelSelectProduct(row.projectId, [row.id])
        // 将数据从table列表中移除
        this.removeProjectProductsData({ index })
        this.$message.success('移除成功')
        // 将数据从已选列表中移除
        const selectIndex = this.selected.findIndex((item) => item.id === row.id)
        if (selectIndex > -1) {
          this.selected.splice(selectIndex, 1)
        }
        // 将totalCount - 1, 防止重新获取表格数据
        this.setTotalCount(this.totalCount - 1)
        // 埋点
        this.$tracks({
          event: 'unselect',
          params: {
            g_c_product_id: row.productId,
            g_c_class_code: row.gjwCategoryCode,
            g_c_class_name: row.gjwCategoryName,
            g_c_selection_project_id: row.projectId,
          }
        })
      } catch (err) {
        this.$message.error('移除失败，请稍后再试')
      } finally {
        this.removingIndex = -1
      }
    },
    // 导出设备表
    async startExportExcel() {
      try {
        this.$fullLoading.open('正在导出设备表，请勿关闭或刷新页面。')
        const ids = this.selected.map((item) => item.id)
        const params = {
          gjwCategoryCode: this.categoryCode,
          personalProductIds: ids,
        }
        const exportKey = await this.$api.project.exportProduct(this.project.id, params)
        if (exportKey) {
          this.queryExportUrl(exportKey)
        }
      } catch (err) {
        this.$message.error('导出失败，请稍后再试。')
        this.$fullLoading.close()
      }
    },
    // 轮询导出的url
    async queryExportUrl(exportKey) {
      try {
        const url = await this.$api.project.getExportUrl(this.project.id, { export_key: exportKey })
        if (url) {
          // 如果有url就下载
          const tempWin = window.open('', '_self')
          tempWin.location.href = url
          this.$fullLoading.close()
          this.selected = []
          // 导出设备表埋点
          this.$tracks({
            event: 'equipMatListExport',
            params: {
              g_c_class_code: this.categoryCode,
              g_c_selection_project_id: this.project.id,
            }
          })
        } else {
          // 继续轮询
          setTimeout(() => {
            this.queryExportUrl(exportKey)
          }, 3000)
        }
      } catch (err) {
        this.$message.error('导出失败，获取下载链接异常')
        this.$fullLoading.close()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .result-box{
    padding: 4px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .text{
      line-height: 28px;
    }
  }
</style>
